import PropTypes from 'prop-types';

export default {
  deregisterField: PropTypes.func.isRequired,
  registerField: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  fieldUpdateDispatcher: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
};
